import { Link } from 'react-router';
import { Lock } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useSessionState } from '@/auth';
import { landingRouteFor } from '@/routes/roleRoutes';
import { messages } from '@/i18n';
import { AuthScreenLayout } from './AuthScreenLayout';

/**
 * A 403, or a route the role is not on the allow-list for.
 *
 * The user stays signed in. A 403 means the app offered a control the role
 * cannot use, which is a bug in its own navigation — signing the user out would
 * hide that bug behind a plausible-looking auth event.
 */
export function NotPermitted() {
  const { session } = useSessionState();

  return (
    <AuthScreenLayout title={messages.notPermitted.title}>
      <Alert>
        <Lock aria-hidden />
        <AlertDescription>{messages.notPermitted.body}</AlertDescription>
      </Alert>
      {session ? (
        <Button asChild variant="outline" className="mt-4 w-full">
          <Link to={landingRouteFor(session.role)}>{messages.notPermitted.action}</Link>
        </Button>
      ) : null}
    </AuthScreenLayout>
  );
}
